export const environment = {
  production: false,
  baseURL:"https://api.dev.pos.eprimerx.com/",
  recaptcha: {
    siteKey: '6LfEhzIrAAAAAOFf9UIFhcYAROJu__kYlnO8B0ir'
  },
  primeRxCloudURL:"https://web-app.uat.eprimerx.com/#/login"
};
